module.exports = __webpack_public_path__ + "static/media/Logo.ec0b8de4.png";